<template>
  <div class="wrapper white_box" style="background-color: #efeff3;padding:0px">
    <!-- 返回按钮 -->
    <div class="back-btn-box">
      <button-a class="goBackBtn" color="#707070" bgcolor="transparent" @click.native="$router.go(-1)">
        <i class="el-icon-back"></i> 返回
      </button-a>
    </div>
    <div style="background: #fff;
    padding: 20px;">
    <div class="content">
      <h2 class="message-title font_18_black">{{data.title}}</h2>
      <p class="font_14_darkgray">接收时间： {{date(data.creationTime)}}</p>
      <div class="font_14_black font_bold message-content">
        <p>{{data.content}}</p>
      </div>
      <div class="to_view font_14_orange">
        <p class="pointer" @click.stop="viewTheBusiness(data)">业务查看</p>
      </div>
    </div>
    <div class="bottom font_14_darkgray">
      <div class="prev pointer" @click="navTo(data.lastId)">
        <span>上一条：</span>
        {{data.lastTitle || '无'}}
      </div>
      <div class="next pointer" @click="navTo(data.nextId)">
        <span>下一条：</span>
        {{data.nextTitle || '无'}}
      </div>
    </div></div>
  </div>
</template>

<script>
import { Get } from "@/js/http.js";
import { dateConvert } from "@/js/tool.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      id: this.$route.params.id,
      data: {},
      loading: true
    };
  },
  watch: {},
  computed: {},
  methods: {
    getData(id) {
      this.loading = true;
      Get(`api/v1/messages/${id}`).then(res => {
        this.data = res.data;
        this.getUnreadNum();
        this.loading = false;
      });
    },
    // 日期转换
    date(date) {
      return dateConvert(date);
    },
    navTo(id) {
      if (!id) return false;
      this.getData(id);
      this.$router.replace({ path: "/MessageItem/" + id });
    },
    // 业务查看
    viewTheBusiness(item) {
      const messageType = parseInt(item.messageType) || parseInt(item.msgType);
      const linkUrl = item.linkUrl || item.url || '';
      
      if (messageType === 1) {
        // 系统消息
        this.$router.push({ name: "TimeLine" });
      } else if (messageType === 2) {
        // 政策公告 - 打开政策公告页面
        this.$router.push({ name: "Policy", params: { noticeID: linkUrl } });
      } else if (messageType === 3) {
        // 协议到期 - 打开对应客户的企业信息页面
        this.$router.push({ name: "UserInfo", params: { customerId: linkUrl } });
      } else if (messageType === 4) {
        // 员工合同到期 - 打开员工合同详情页面
        this.$router.push({ name: "EmployeeContractItem", params: { id: linkUrl } });
      } else if (messageType === 5) {
        // 报表通知 - 打开用工数据报表页面
        this.$router.push({ name: "EmploymentData" });
      } else if (messageType === 6) {
        // 员工信息 - 打开员工信息详情页面
        this.$router.push({ name: "EmployeeInfoItem", params: { id: linkUrl } });
      } else if (messageType === 7) {
        // 薪资详情 - 打开薪资详情页面
        this.$router.push({ name: "SalaryDetailsItem", params: { pkid: linkUrl, setType: '1' } });
      } else if (linkUrl) {
        // 如果有链接但类型不匹配，直接跳转
        if (linkUrl.startsWith('http')) {
          window.open(linkUrl, '_blank');
        } else {
          this.$router.push({ path: linkUrl });
        }
      } else {
        // 默认跳转到首页
        this.$router.push({ name: "Home" });
      }
    },
    // 跳转
    navToLink(link) {
      if (link) {
        location.href = link;
      } else {
        return false;
      }
    },
    getUnreadNum(){
      Get("api/v1.0/global/messages/unread").then(res=>{
         localStorage.setItem("unreadNum", res.data); // local存储未读信息数量
         this.$store.state.unreadNum=res.data;
      }).catch(() => {
      });
    },
  },
  created() {},
  mounted() {
    this.getData(this.id);
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 32px;
  padding: 62px 104px;
  .content {
    padding-bottom: 50px;
    border-bottom: 1px solid #e5e5e5;
    overflow-x: auto;
    .message-content {
      margin-top: 45px;
      margin-bottom: 25px;
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 46px;
    height: 50px;
  }
  .back-btn-box {
    margin-bottom: 32px;
  }
  .goBackBtn {
    font-size: 16px !important;
    border: none !important;
    border-color: transparent !important;
  }
}
</style>